module.exports = "https://static.wagwalking.com/_next/static/images/Avatar-1-ec875c09a4e980c5a1238990565e6df2.svg";